<template>
  <b-modal
    id="scoutScreen"
    ref="scoutScreen"
    size="xl"
    hide-header
    hide-footer
    @hidden="onModalHidden"
  >
    <IndividualContact2
      ref="individualContact"
      :applicant_id="applicant_id"
      :applicantIndex="index"
      :showNavigation="true"
      :contactListType="contactListType"
      @changeIndex="changeIndex"
      @close="hideModal"
    />
  </b-modal>
</template>

<script>
import IndividualContact2 from './IndividualContact2.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'IndividualContactModal',
  props: ['applicant_id', 'applicantIndex', 'contactListType'],
  components: { IndividualContact2 },
  data() {
    return {
      index: this.applicantIndex,
      applicantId: this.applicant_id,
    };
  },
  computed: {
    ...mapState({
      currentPageApplicants: ({ applicant }) => applicant.currentPageApplicants,
      applicants: ({ applicant }) => applicant.applicants,
    }),
  },
  methods: {
    ...mapMutations({
      setPage: 'setPage',
      setReloadApplicants: 'setReloadApplicants',
    }),
    hideModal() {
      this.$refs.scoutScreen.hide();
    },
    onModalHidden() {
      this.$emit('hidden');
      if (this.currentPageApplicants.length !== this.applicants.length) {
        this.setReloadApplicants(true);
      }
    },
    cancel() {
      this.openMessageComposeForm = false;
      this.showReplyForm = false;
      // this.selectedMessageId = null;
    },
    changeApplicant(index) {
      this.applicantId = this.applicants[index].id;
      this.index = index;
      this.applicantJd = this.currentApplicantJd;
      //   this.isFavorited = this.applicants[index].isFavorite;
      //   this.isInterviewed = this.applicants[index].isInterview;
    },
    changeIndex(index) {
      this.index = index;
    },
    show() {
      this.$refs.scoutScreen.show();
    },
  },
  mounted() {
    this.show();
  },
  watch: {
    applicantIndex(value) {
      this.index = value;
    },
  },
};
</script>

<style scoped>
.fa-chevron-right,
.fa-chevron-left {
  font-size: 1.5rem !important;
}
:deep(.modal-footer) {
  justify-content: space-between;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 1000;
}

::v-deep .modal-xl {
  max-width: 90vw !important;
}

::v-deep .modal-body {
  padding: 0px !important;
  overflow-x: hidden;
  overflow-y: hidden;
  min-height: calc(90vh - 120px);
  display: flex;
  flex-direction: column;
}
.modal-content-wrapper {
  flex: 1;
  min-height: 500px; /* Minimum height to prevent footer jumping */
  display: flex;
  flex-direction: column;
}

.btn-cancel {
  border-color: #3c3c3c;
  color: #3c3c3c;
  border-radius: 4px;
}
</style>
